import { AfterViewInit, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { AuthService, MenuService, StoreService } from '../../services';
import { breakpoints } from '../../environments/environment.breakpoints';
import { NavbarService } from '../../services/navbar.service';
import { Router } from '@angular/router';
@Component({
  selector: 'ct-navbar',
  templateUrl: './ct-navbar.component.html',
  styleUrls: ['./ct-navbar.component.css']
})
export class CtNavbarComponent implements AfterViewInit {

  public isHelpWindowVisible : boolean = false;
  public isMediumSize: boolean = false;
  public isSmallSize: boolean = false;
  public isExtraSmall: boolean = false;
  private readonly ORGANIZATION_VIEW = 'SG_VI06';
  private readonly USER_ROLES : Set<string> = new Set(['ADMINISTRACION_PLANILLAS',
  'TESORERIA_PLANILLAS', 'PLANILLERO_ROLE']);

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.manageWindowResizing(window.innerWidth);
  }

  private manageWindowResizing(width: number) {
    this.isSmallSize = width < breakpoints.L && width >= breakpoints.M;
    this.isExtraSmall = width >= breakpoints.S && width < breakpoints.M;
    this.isMediumSize = width >= breakpoints.L;
  }

  constructor(private menuService: MenuService,
    private navbarService : NavbarService,
    private router : Router,
    private authService : AuthService){
  }

  ngAfterViewInit(): void {
    this.navbarService.setNavbarComponent(this);
  }
  
  @Output() menuClick = new EventEmitter<void>();

  onMenuNavClick() {
    this.menuClick.emit();
  }

  clickHelp() {
    this.isHelpWindowVisible = !this.isHelpWindowVisible;
  }

  clickNotification() {
    console.log("clickNotification")
  }

  logOut() {
    this.menuService.logOut();
  }

  toggleHelpMenu(): void {
    this.isHelpWindowVisible = !this.isHelpWindowVisible;
  }

  startGuidedTour(): void {
    localStorage.setItem('guidedTour', 'true');
    const url : string = '/home/view/PA_VI01';
    if (this.router.url === url) {
      window.location.href = url;
    } else {
      this.router.navigate([url]);
    }
  }

  openHelpCenter(): void {
    const url : string = '/home/view/AV_VI17';
    if (this.router.url === url) {
      window.location.href = url;
    } else {
      this.router.navigate([url]);
    }
  }

  openOrganizationView(): void {
    this.router.navigate([`/home/view/${this.ORGANIZATION_VIEW}`]);
  }

  userHasOrganization(): boolean {
    if( this.authService.userRoles.some((role : string) => this.USER_ROLES.has(role))){
      return true;
    } 
    return false;
  }
}